import React from 'react';
import { useEmbedReachability } from './useEmbedReachability';
import EmbedUnavailablePanel from './EmbedUnavailablePanel';

/**
 * Drop-in iframe that probes reachability first and shows a friendly
 * unavailable panel instead of the browser connection-error page.
 */
export default function SafeIframe({
  src,
  title,
  serviceName,
  className,
  style,
  sandbox,
  allow,
  onLoad,
  onError,
  iframeRef,
  loadingLabel,
}) {
  const { status, retry, retryKey } = useEmbedReachability(src);
  const label = serviceName || title || 'This service';

  return (
    <div className={className} style={{ position: 'relative', width: '100%', height: '100%', ...style }}>
      {status === 'checking' && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            zIndex: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#f9fafb',
            color: '#6b7280',
            fontSize: 14,
          }}
        >
          {loadingLabel || `Loading ${label}…`}
        </div>
      )}

      {status === 'unavailable' && (
        <EmbedUnavailablePanel serviceName={label} src={src} onRetry={retry} />
      )}

      {status === 'ready' && src ? (
        <iframe
          key={`${src}:${retryKey}`}
          ref={iframeRef}
          src={src}
          title={title || label}
          className="h-full w-full border-0"
          style={{ border: 'none', width: '100%', height: '100%', display: 'block' }}
          sandbox={sandbox}
          allow={allow}
          onLoad={onLoad}
          onError={onError}
        />
      ) : null}
    </div>
  );
}
